module.exports = __webpack_public_path__ + "img/enter-detail.39081d79.svg";